<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>

    <v-row class="fill-width">
      <v-col cols="12">
        <v-row class="mx-3 mt-4">
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                filled
                v-model="warranty.phone"
                label="Số điện thoại"
                placeholder="Nhập tên category"
                @input="debounceInput"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
              filled
              v-model="warranty.stamp"
              label="Mã tem sản phẩm"
              placeholder="Mã tem sản phẩm"
              @input="debounceInput1"
          ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                filled
                v-model="warranty.seri"
                label="Seriel"
                placeholder="Seriel"
                @input="debounceInput2"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-select
                filled
                class="width-input"
                v-model="warranty.status"
                :items="warranty_status"
                clearable
                item-text="name"
                item-value="id"
                label="Trạng thái"
                @change="getItem"
            ></v-select>
          </v-col>
<!--          <v-col cols="1.5">-->
<!--            <v-btn color="primary" @click="getItem"> Search </v-btn>-->
<!--          </v-col>-->
        </v-row>
      </v-col>
<!--      <v-col cols="2" align="right" class="mt-7">-->
<!--        <v-btn color="primary" align="right" @click="addNew">-->
<!--          Thêm-->
<!--        </v-btn>-->
<!--      </v-col>-->
    </v-row>

    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="dataResult"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.status="{ item }">
              <span v-if="item.status == 1" class="red--text font-weight-bold">CHỜ DUYỆT</span>
              <span v-else class="primary--text font-weight-bold">ĐÃ DUYỆT</span>
            </template>
            <template v-slot:item.created_at="{ item }">
             <span>{{formatDate(item.created_at)}}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update warranty')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete warranty')"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

import { GET_LIST_PRODUCT_ERROR,DELETE_PRODUCT_ERROR ,GET_DATA_SEARCH} from "@/store/modules/product_error";
import { mapGetters } from "vuex";
import {debounce} from "debounce";
export default {
  data() {
    return {
      page: "Báo lỗi sản phẩm",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Bảo hành",
          disabled: true,
        },
        {
          text: "Báo lỗi sản phẩm",
          disabled: true,
        },
      ],
      warranty: {
        phone:"",
        status:"",
        seri:"",
        stamp:"",
        limit: 10,
      },
      active: [
        {id:1, name:'CHƯA KÍCH HOẠT'},
        {id:2, name:'ĐÃ BẢO HÀNH'},
      ],
      warranty_status: [
        {id:1, name:'CHỜ DUYỆT'},
        {id:2, name:'ĐÃ DUYỆT'},
      ],
      headers: [
        { text: "STT", value: "id" },
        { text: "Họ và tên", value: "warranty.customer_fullname" },
        {
          text: "SĐT",
          align: "start",
          sortable: false,
          value: "warranty.customer_phone",
        },
        { text: 'Tên sản phẩm', value: 'warranty.name_product' },
        { text: 'Mã tem sản phẩm', value: 'warranty.stamp' },
        { text: 'Seriel', value: 'warranty.seri' },
        { text: 'Note', value: 'node' },
        { text: 'Thời gian', value: 'created_at' },
        { text: 'Trạng thái', value: 'status' },
        { text: 'Actions', value: 'actions' },
      ],
      url: "",
    };
  },
  computed: {
    ...mapGetters({
      productErrorReports: "productErrorReports",
      dataResult: "dataSearchErrors",
    }),
  },
  watch: {
    productErrorReports(val){
      console.log(val)
    }
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL;
    await this.$store.dispatch(GET_LIST_PRODUCT_ERROR);
    await this.$store.dispatch(GET_DATA_SEARCH);
  },
  methods: {
    debounceInput: debounce(function (e) {
      this.warranty.phone = e;
      let param = {
        phone: this.warranty.phone,
        seri: this.warranty.seri,
        stamp:this.warranty.stamp,
        status: this.warranty.status != "-1" ? this.warranty.status : null,
      };
      this.$store.dispatch(GET_DATA_SEARCH, param);
    }, 200),

    debounceInput1: debounce(function (e) {
      this.warranty.stamp = e;
      let param = {
        phone: this.warranty.phone,
        seri: this.warranty.seri,
        stamp:this.warranty.stamp,
        status: this.warranty.status != "-1" ? this.warranty.status : null,
      };
      this.$store.dispatch(GET_DATA_SEARCH, param);
    }, 200),

    debounceInput2: debounce(function (e) {
      this.warranty.seri = e;
      let param = {
        phone: this.warranty.phone,
        seri: this.warranty.seri,
        stamp:this.warranty.stamp,
        status: this.warranty.status != "-1" ? this.warranty.status : null,
      };
      this.$store.dispatch(GET_DATA_SEARCH, param);
    }, 200),
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    getItem() {
      let param = {
        phone: this.warranty.phone,
        //limit : 10,
        seri: this.warranty.seri,
        stamp:this.warranty.stamp,
        status: this.warranty.status != "-1" ? this.warranty.status : null,
      };
      this.$store.dispatch(GET_DATA_SEARCH, param);
    },
    editItem(item) {
      this.$router.push(
          "/manage_warranty/edit_error/" + item.id
      );
    },

    deleteItem(id) {
      confirm("Bạn có chắc muốn xóa?") &&
      this.$store.dispatch(`${DELETE_PRODUCT_ERROR}`, id).then((data) => {
        if (data && data.status === 1) {
          let param = {
            phone: this.warranty.phone,
            seri: this.warranty.seri,
            stamp:this.warranty.stamp,
            status: this.warranty.status != "-1" ? this.warranty.status : null,
          };
          this.$store.dispatch(GET_DATA_SEARCH, param);
        }
      });
    },
    // addNew() {
    //   this.$router.push("/active_warranty/add_warranty");
    // },
  },
};
</script>
<style scoped lang="scss">
.content_category1 {
  background: #ffffff !important;
}
.width-input {
  max-width: 240px!important;
}
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
</style>
